import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import JsPdf from "jspdf";
import SignatureCanvas from 'react-signature-canvas';
import contract_page1 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0001.jpg'
import contract_page2 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0002.jpg'
import contract_page3 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0003.jpg'
import contract_page4 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0004.jpg'
import contract_page5 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0005.jpg'
import contract_page6 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0006.jpg'
import contract_page7 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0007.jpg'
import contract_page8 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0008.jpg'
import contract_page9 from '../../../Contracts/Contrato_Base_Clientes_VF/WBD-FINAL_page-0009.jpg'

import { Bounce } from 'react-activity';
import font from '../../../fonts/calibri-regular.ttf'
import fontS from '../../../fonts/calibri-regular.js'

const Contract = ({show, handleClose, data, uploadContract, Loading, traductions, ...props}) => {

    const [document, setdoc] = useState('')
    const ref = useRef(null)
    const [pic, setpic] = useState('')
    const [contract, setContract] = useState('')
    const [contractB64, setcontractB64] = useState('')
    const [LoadingLocal, setLoading] = useState(false)

    useEffect(() => {
        generatePdf()
    }, [])

    useEffect(() => {
        generatePdf()
    }, [contract, data, pic])

    useEffect(() => {
        if(contractB64){
            uploadContract(contractB64)
        }
    }, [contractB64])

    const loadImage = (url) => {
        return new Promise((resolve) => {
          let img = new Image();
          img.onload = () => resolve(img);
          img.src = url;
        })
    }

    const isEmpty = (obj) => {
        return obj && Object.keys(obj).length === 0 && obj.constructor === Object
    }

    const generatePdf = (sending) =>{
        if(!isEmpty(data)){
/* ------------------------------- Propiedades ------------------------------ */
            var today = new Date();
            // var doc = new JsPdf('portrait', 'mm', 'letter',true);
            var doc = new JsPdf({ orientation: "portrait", unit: "mm", format: 'letter',compress:true });
            doc.setFontSize(9.5);
            // doc.setTextColor(255,0,0);


/* ---------------------------- Justificar texto ---------------------------- */
            var lMargin=30; //left margin in mm
            var rMargin=30; //right margin in mm
            var pdfInMM=215.9;  // width of A4 in mm
            var pageCenter=pdfInMM/2;

/* ----------------------------- Pagina 1 ----------------------------- */
            loadImage(contract_page1).then((page) => {

                doc.addImage(page, 'JPG', 0, 0, 216,279 );

                let line2 = `CONTRATO DE PRESTACIÓN DE SERVICIOS QUE CELEBRAN POR UNA PARTE 'WIREBIT, S.A.P.I DE C.V.' (EN ADELANTE REFERIDA COMO “WIREBIT”), REPRESENTADA EN ESTE ACTO POR SU REPRESENTANTE LEGAL, Y POR LA OTRA PARTE ${data.Nombre} (EN ADELANTE REFERIDA COMO “EL CLIENTE”); A TODOS LOS ANTERIORES DE MANERA CONJUNTA SE LES DENOMINARÁ “LAS PARTES”, DE CONFORMIDAD CON LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:`

                var lines =doc.splitTextToSize(line2, (pdfInMM-lMargin-rMargin));
                doc.text(lines,30,28.5,{ align: "justify", maxWidth: pdfInMM-lMargin-rMargin })
                //
                doc.setFontSize(9);
                // doc.text(data.ID_RFC ,155,193.5,'left') //numero id rfc
                doc.text(data.ID_RFC ,170,189.8,'left') //numero id rfc
                doc.text(data.Direccion,43,207,'left') //numero id rfc

            /* ----------------------------- Pagina 2 ----------------------------- */
                doc.addPage();
                loadImage(contract_page2).then((page) => {
                    doc.addImage(page, 'JPG', 0, 0, 216,279 );
                    doc.text(data.Direccion,43,64.5,'left') //numero id rfc
                    doc.text(data.ID_RFC ,137.2,69.9,'left') //numero id rfc

                /* ----------------------------- Pagina 3 ----------------------------- */
                    doc.addPage();
                    loadImage(contract_page3).then((page) => {
                        doc.addImage(page, 'JPG', 0, 0, 216,279 );
                    /* ----------------------------- Pagina 4 ----------------------------- */
                        doc.addPage();
                        loadImage(contract_page4).then((page) => {
                            doc.addImage(page, 'JPG', 0, 0, 216,279 );
                        /* ----------------------------- Pagina 5 ----------------------------- */
                            doc.addPage();
                            loadImage(contract_page5).then((page) => {
                                doc.addImage(page, 'JPG', 0, 0, 216,279 );
                            /* ----------------------------- Pagina 6 ----------------------------- */
                                doc.addPage();
                                loadImage(contract_page6).then((page) => {
                                    doc.addImage(page, 'JPG', 0, 0, 216,279 );
                                /* ----------------------------- Pagina 7 ----------------------------- */
                                    doc.addPage();
                                    loadImage(contract_page7).then((page) => {
                                        doc.addImage(page, 'JPG', 0, 0, 216,279 );
                                        // doc.text(`los días ${String(today.getDate()).padStart(2, '0')} del mes de ${monthNames[today.getMonth()]} de ${today.getFullYear()}.`,110,132.7,'left') //3 inicio // 65 fin //31 mitad primer intento
                                        doc.text(`los días ${String(today.getDate()).padStart(2, '0')} del mes de ${monthNames[today.getMonth()]} de ${today.getFullYear()}.`,30,142.7,'left') //3 inicio // 65 fin //31 mitad primer intento
                                        doc.text(data.Nombre, pageCenter + 45, 185, 'center'); // Nombre completo
                                        if(pic){
                                            // doc.addImage(pic, 'PNG',  37, 198, 58, 10); // CHAPA FIRMA
                                            doc.addImage(pic, 'PNG',  121, 165, 58, 10); // CLIENTE FIRMA
                                        }
                                    /* ----------------------------- Pagina 8 ----------------------------- */
                                        doc.addPage();
                                        loadImage(contract_page8).then((page) => {
                                            doc.addImage(page, 'JPG', 0, 0, 216,279 );
                                            let line2 = `QUE FORMA PARTE DEL CONTRATO DE PRESTACIÓN DE SERVICIOS CELEBRADO POR UNA PARTE WIREBIT S.A.P.I DE C.V., A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ “WIREBIT” Y, POR OTRA PARTE, ${data.Nombre} A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ EL “CLIENTE”, EN CONJUNTO SE LES DENOMINARÁ LAS PARTES.`
                                            var lines =doc.splitTextToSize(line2, (pdfInMM-lMargin-rMargin));
                                            // doc.text(lines,30,48.5,'left')
                                            doc.text(lines,30,48.5,{ align: "justify", maxWidth: pdfInMM-lMargin-rMargin })

                                            doc.text(`${String(today.getDate()).padStart(2, '0')} del mes de ${monthNames[today.getMonth()]} de ${today.getFullYear()}.`, 100,163.3,'left')
                                            doc.text(data.Nombre, pageCenter + 37.5, 208, 'center'); // Nombre completo
                                            if(pic){
                                                doc.addImage(pic, 'PNG',  122, 194, 58, 10); // CLIENTE FIRMA
                                            }
                                        /* ----------------------------- Pagina 9 ----------------------------- */
                                            doc.addPage();
                                            loadImage(contract_page9).then((page) => {
                                                doc.addImage(page, 'JPG', 0, 0, 216,279 );

                                                let line2 = `QUE FORMA PARTE DEL CONTRATO DE PRESTACIÓN DE SERVICIOS CELEBRADO POR UNA PARTE WIREBIT S.A.P.I DE C.V., A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ “WIREBIT” Y, POR OTRA PARTE, ${data.Nombre} A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ EL “CLIENTE”, EN CONJUNTO SE LES DENOMINARÁ LAS PARTES.`
                                                var lines =doc.splitTextToSize(line2, (pdfInMM-lMargin-rMargin));
                                                // doc.text(lines,30,45,'left')
                                                doc.text(lines,28,50,{ align: "justify", maxWidth: pdfInMM-lMargin-rMargin })
                                                doc.text(`${String(today.getDate()).padStart(2, '0')} del mes de ${monthNames[today.getMonth()]} de ${today.getFullYear()}.`,100,171.9,'left')
                                                doc.text(data.Nombre, pageCenter + 44.5, 222, 'center'); // Nombre completo
                                                if(pic){
                                                    doc.addImage(pic, 'PNG',  124, 205, 58, 10); // CLIENTE FIRMA
                                                }

                                                if(sending){
                                                    setcontractB64(doc.output('dataurlstring').substring(51,doc.output('dataurlstring').length) )
                                                }

                                                if(document === ''){
                                                    setdoc(doc.output('bloburl'))
                                                }


                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            });

        }
    }

    const firmaCompletada = () => {
        var sefg = ref.current.getCanvas().toDataURL('image/png');
        setpic(sefg)
    }

    return (
        <Modal backdrop="static" keyboard={false} show={show} onHide={handleClose}>
             <Modal.Body>
                 <p style={{fontFamily:'Calibri'}}>{traductions.kyc.form.Contract}</p>
                 <div style={{display:'flex', alignItems:'center', flexDirection:'column'}}>

                    <iframe src={document} style={{marginBottom:'2em'}} width={240*2} height={360*1}   type="application/pdf"></iframe>

                    <div style={{display:'flex', justifyContent:'space-between', width:'100%'}}>
                        <p >{traductions.kyc.form.Signature}</p>
                        <p onClick={()=>{ref.current.clear(); setpic('')}} className='link'>{traductions.kyc.form.Clear} ⟳</p>
                    </div>

                    <SignatureCanvas
                        penColor='blue'
                        canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                        onEnd={() => { firmaCompletada() }}
                        ref={ref}
                        // backgroundColor='rgba(255,0,0,8)'
                    />

                </div>
                <br/>
                <center >
                    <Button onClick={() => { setLoading(true); generatePdf(true)}}
                                    disabled={(pic === '' || Loading)}
                                    className="signup-button" variant="primary">
                        {
                            (Loading)
                            ?<Bounce size={20} color={"#FFFFFF"} animating={true} />
                            :traductions.kyc.form.Confirm
                        }

                    </Button>
                </center>
             </Modal.Body>
        </Modal>
     );
}

export default Contract;

const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];
// const monthNames = ["January", "February", "March", "April", "May", "June",
//   "July", "August", "September", "October", "November", "December"
// ];
